var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 14.6667C11.6666 14.6667 14.6666 11.6667 14.6666 8.00001C14.6666 4.33334 11.6666 1.33334 7.99998 1.33334C4.33331 1.33334 1.33331 4.33334 1.33331 8.00001C1.33331 11.6667 4.33331 14.6667 7.99998 14.6667Z",
    stroke: "#4A00E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16669 8.00001L7.05335 9.88668L10.8334 6.11334",
    stroke: "#4A00E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.9bef1f9273e82740def413134b8b0fb8.svg";
export { ForwardRef as ReactComponent };